import { useTranslation } from '@kc-console/core';
import IcCloseSmallThin from '@kep/kcds-icons/IcCloseSmallThin';

import { IconButtonGhost } from '../IconButtonGhost';

import type { ToastCloseButtonProps } from './types';

const ToastCloseButton = (props: ToastCloseButtonProps) => {
  const { t } = useTranslation();

  return (
    <IconButtonGhost
      size="sm"
      variant="inverse"
      aria-label={t('common:common.action.close')}
      {...props}
    >
      <IcCloseSmallThin fontSize={'24px'} />
    </IconButtonGhost>
  );
};

export default ToastCloseButton;
